import React from "react";
import ProductosPage from './ProductosPage';

function AdminPage() {
  return (
    <div>
      <ProductosPage />
    </div>
  );
}

export default AdminPage;
